import {
  Checkbox,
  CheckboxGroup,
  Inputs,
  RadioGroup,
  StartWidgetWrapper,
  UnitInput,
} from '@kizi/comparator-components';
import {
  Button,
  Anchor as CoreAchor,
  Select as CoreSelect,
  Div,
  Heading,
  Image,
  Input,
  Label,
  List,
  ListItem,
  P,
  Span,
  Svg,
} from '@kizi/core-components';
import { AdditionalChannels } from './AdditionalChannels';
import { AvailableNetworks } from './AvailableNetworks';
import { CombinationDiscount } from './CombinationDiscount';
import {
  CommentWithAvatar,
  CommentWithAvatarWrapper,
} from './CommentWithAvatar';
import { CustomerBenefit } from './CustomerBenefit';
import { FormSubmitWrapper } from './FormSubmitWrapper';
import { SpecificChannelSearch } from './Inputs/SpecificChannelSearch';
import { OverviewTopMessage } from './OverviewTopMessage';
import { CheckoutPage } from './Pages/CheckoutPage';
import { RetentionDisclaimer } from './RetentionDisclaimer';
import { SpeedPopup } from './SpeedPopup';
import { AffiliateUrlModalWrapper } from './wrappers/ AffiliateUrlModalWrapper';
import { PackageCheckbox } from './wrappers/Checkbox/PackageCheckbox';
import { HowItWorksWrapper } from './wrappers/HowItWorksWrapper';
import { ProductSummaryWrapper } from './wrappers/ProductSummaryWrapper';
import { ProductCardTriplePlay } from './ProductCardTriplePlay/ProductCardTriplePlay';
import { ProductCardTriplePlayTopThree } from './ProductCardTriplePlay/ProductCardTriplePlayTopThree';
export { IncentiveContent } from './incentivePromotionContent/IncentiveContent';
export { WidgetBadge } from './WidgetBadge';
// Empty components to make sure the apply page doesn't break, to be created!
const Info = () => null;
const AddressBirthdateDisplay = () => null;
const AfterTheSwitchWrapper = () => null;

// Exports
export * from '@kizi/comparator-components';
export * from '@kizi/shared-components';
export * from '../utils/filterQuery';
export { GoBackIconButton } from './GoBackIconButton';
export * from './Pages';
export * from './TextWithLink';
export {
  AdditionalChannels,
  AddressBirthdateDisplay,
  AffiliateUrlModalWrapper,
  AfterTheSwitchWrapper,
  AvailableNetworks,
  Button,
  Checkbox,
  CheckboxGroup,
  CheckoutPage,
  CombinationDiscount,
  CommentWithAvatar,
  CommentWithAvatarWrapper,
  CoreAchor,
  CoreSelect,
  CustomerBenefit,
  Div,
  FormSubmitWrapper,
  Heading,
  HowItWorksWrapper,
  Image,
  Info,
  Input,
  Inputs,
  Label,
  List,
  ListItem,
  OverviewTopMessage,
  P,
  PackageCheckbox,
  ProductSummaryWrapper,
  RadioGroup,
  RetentionDisclaimer,
  Span,
  SpecificChannelSearch,
  SpeedPopup,
  StartWidgetWrapper,
  Svg,
  UnitInput,
  ProductCardTriplePlay,
  ProductCardTriplePlayTopThree,
};
